<template>
  <el-dialog
      :visible.sync="visible"
      title="发货单修改"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="100px"
        :rules="dataRule"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="外销合同号：">
            {{ dataForm.orderCode }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货批次号：">
            {{ dataForm.batchCode }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="发货方：" prop="senderId">
            <company v-model="dataForm.senderId" :disabled="true"></company>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收货方：" prop="receiverId">
            {{ dataForm.receiverName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="发货数：" prop="sendCount">
            <el-input type="text" size="mini" v-model="dataForm.sendCount"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收货数：" prop="count">
            <el-input type="text" size="mini" v-model="dataForm.count" :disabled="dataForm.status===10"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="发货时间：" prop="operateTime">
            <el-date-picker
                v-model="dataForm.operateTime"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收货时间：" prop="receiveOptTime">
            <el-date-picker
                v-model="dataForm.receiveOptTime"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                :disabled="dataForm.status===10"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="" label-width="0" style="margin-left: 45px;">
            <ProductRowCard :product="dataForm.product"></ProductRowCard>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货单价" prop="price">
            <el-input type="text" size="mini" v-model="dataForm.price"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="12">
          <el-form-item label="备注：">
            {{ dataForm.fullRemark }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button type="primary" size="small" @click="doSubmit">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import ProductRowCard from '@/components/ProductRowCard.vue'
import { isPositiveNumber, priceValidator } from '@/utils/validate'

export default {
  name: 'ChangePriceDialog',
  components: { ProductRowCard },
  data () {
    return {
      visible: false,
      dataForm: {},
    }
  },
  computed: {
    canEditSender(){
      if(this.$c.isAdmin()){
        return false
      }
      return true
    },
    dataRule () {
      return {
        sendCount: [
          { required: true, message: '请输入发货数量', trigger: 'change' },
          {
            validator: (rule, value, callback, source, options, msg) => {
              console.log(value, isPositiveNumber(value))
              if (!isPositiveNumber(value)) {
                callback(new Error('发货数量必须为正数'))
              }
              if (parseFloat(value) <= 0) {
                callback(new Error('发货数量必须大于0'))
              }
              callback()
            }, trigger: 'change'
          }
        ],
        count: [
          { required: this.dataForm.status === 20, message: '请输入收货数量', trigger: 'change' },
          {
            validator: (rule, value, callback, source, options, msg) => {
              if (!value) {
                callback()
                return
              }
              if (!isPositiveNumber(value)) {
                callback(new Error('发货数量必须为正数'))
              }
              if (parseFloat(value) <= 0) {
                callback(new Error('发货数量必须大于0'))
              }
              callback()
            }, trigger: 'change'
          }
        ],
        senderId: [{ required: true, message: '请输入发货方', trigger: 'change' },],
        operateTime: [{ required: true, message: '请输入发货时间', trigger: 'change' },],
        receiveOptTime: [{ required: this.dataForm.status === 20, message: '请输入收货时间', trigger: 'change' },],
        price: [
          { required: true, message: '请输入发货单价', trigger: 'change' },
          { validator: priceValidator, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init (data) {
      this.dataForm = {
        ...data,
        count: data.count === 0 ? '' : data.count
      }
      console.log(this.dataForm)
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    async doSave () {
      let postForm = {
        id: this.dataForm.id,
        senderId: this.dataForm.senderId,
        receiverId: this.dataForm.receiverId,
        operateTime: this.dataForm.operateTime,
        receiveOptTime: this.dataForm.receiveOptTime,
        sendCount: this.dataForm.sendCount,
        count: this.dataForm.count,
        price: this.dataForm.price
      }
      let loading = this.$loading({
        lock: true,
        text: '正在提交中...'
      })
      try {
        let res = await this.$api2.post('/trade/factorystorelog/edit', postForm)
        this.$message.success('保存成功')
        this.$emit('changed')
        this.visible = false
      } catch (e) {
        console.log(e)
      } finally {
        loading.close()
      }
    },
    doSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.doSave()
      })
    }
  }
}
</script>

<style scoped>

</style>
